import _extends from "@babel/runtime/helpers/extends";
import React, { useCallback, useMemo } from 'react';
import { FormattedMessage } from 'react-intl-next';
import { LazySuspense } from 'react-loosely-lazy';
import { PrimaryDropdownButton } from '@atlaskit/atlassian-navigation';
import ChevronRightIcon from '@atlaskit/icon/glyph/chevron-right';
import { ButtonItem } from '@atlaskit/menu';
import { Flex } from '@atlassian/eoc-flex';
import { usePeopleAndTeamsPeopleMenuConfiguration } from '@atlassian/people-teams-configuration-client/people-menu';
import { usePeopleMenuContext } from '../../context/PeopleMenuContext';
import { messages } from '../i18n';
import { RenotifySpotlight } from './lazy-renotify-spotlight';
import RenotifyMenuButton from './RenotifyMenuButton';
export function PeopleMenuTriggerSSR({
  testId,
  peopleText
}) {
  const remoteConfig = usePeopleAndTeamsPeopleMenuConfiguration();
  const navLabel = (remoteConfig === null || remoteConfig === void 0 ? void 0 : remoteConfig.navLabel) || peopleText;
  return /*#__PURE__*/React.createElement(PrimaryDropdownButton, {
    testId: `${testId}-people-primary-button-ssr`
  }, navLabel ? navLabel : /*#__PURE__*/React.createElement(FormattedMessage, messages.teams));
}
function PeopleMenuTrigger(props) {
  const {
    isSpotlightActive,
    renotifyExperimentProps
  } = usePeopleMenuContext();
  const {
    isVisible,
    isHighlighted,
    customChevronIcon,
    triggerProps,
    onClick,
    onMouseEnter,
    testId,
    isSelected,
    peopleText
  } = props;
  const buttonProps = useMemo(() => ({
    isSelected,
    onClick,
    onMouseEnter,
    testId
  }), [isSelected, onClick, onMouseEnter, testId]);
  const remoteConfig = usePeopleAndTeamsPeopleMenuConfiguration();
  const navLabel = (remoteConfig === null || remoteConfig === void 0 ? void 0 : remoteConfig.navLabel) || peopleText;
  const chevron = customChevronIcon || /*#__PURE__*/React.createElement(ChevronRightIcon, {
    label: "dropdown-chevron"
  });
  const renderPrimaryDropDownButton = useCallback(() => {
    return /*#__PURE__*/React.createElement(PrimaryDropdownButton, _extends({
      isHighlighted: isHighlighted
    }, buttonProps, triggerProps), navLabel || /*#__PURE__*/React.createElement(FormattedMessage, messages.teams));
  }, [buttonProps, isHighlighted, navLabel, triggerProps]);
  if (isVisible) {
    if (renotifyExperimentProps !== null && renotifyExperimentProps !== void 0 && renotifyExperimentProps.isEnrolled && isSpotlightActive !== false) {
      return /*#__PURE__*/React.createElement(LazySuspense, {
        fallback: renderPrimaryDropDownButton()
      }, /*#__PURE__*/React.createElement(Flex, {
        alignItems: "center"
      }, /*#__PURE__*/React.createElement(RenotifySpotlight, {
        "data-testid": "renotify-spotlight-trigger",
        setIsOpen: onClick,
        renderFallback: renderPrimaryDropDownButton
      }, /*#__PURE__*/React.createElement(RenotifyMenuButton, {
        testId: "renotify-menu-trigger-button",
        triggerProps: triggerProps
      }, navLabel || /*#__PURE__*/React.createElement(FormattedMessage, messages.teams)))));
    }
    return renderPrimaryDropDownButton();
  }
  return /*#__PURE__*/React.createElement(ButtonItem, _extends({
    iconAfter: chevron
  }, triggerProps, buttonProps), navLabel || /*#__PURE__*/React.createElement(FormattedMessage, messages.teams));
}
export default PeopleMenuTrigger;